import { render, staticRenderFns } from "./SettingMenu.vue?vue&type=template&id=6dc0690f&scoped=true&"
import script from "./SettingMenu.vue?vue&type=script&lang=js&"
export * from "./SettingMenu.vue?vue&type=script&lang=js&"
import style0 from "./SettingMenu.vue?vue&type=style&index=0&id=6dc0690f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc0690f",
  null
  
)

export default component.exports